import React from 'react';
import './App.scss';
// import Signup from './components/signup'
import Signin from './components/signin'
import { auth, logout } from './firebase';
import Footer from './components/footer';
import Meals from './components/meals/meals';

class App extends React.Component {
	constructor() {
		super();
		this.state = {
			user: null,
			showForm: null,
		}
		this.showAuthForm = this.showAuthForm.bind(this)
	}

	componentDidMount() {
		auth.onAuthStateChanged((user) => {
			if (user) {
				this.setState({ user });
			} 
		});
	}

	logout  = () => {
		const onSuccess = () => this.setState({user: null})
		logout(onSuccess)
	}

	showAuthForm(id) {
		this.setState({showForm: id})
	}

	renderUser() {
		const userName = this.state.user ? this.state.user.email : null

		return (
			<div className='header-user'>
				<h1><strong>Welcome to Jessy's Menu</strong></h1>
				{userName ? <p>Logged in as, <span>{userName}</span>! </p> : <p>Sign in if you are Jessy</p>}

				{this.state.user ? 
					<div style={{marginTop: 10}}>
						<button onClick={this.logout}>Log Out</button> 
					</div>
					: 
					<div className="header-button-wrapper">
						<Signin showAuthForm={this.showAuthForm} showForm={this.state.showForm}></Signin>
						{this.state.showForm === "signin" && <button className='button-link' onClick={() => this.setState({showForm: null})}>Nevermind</button>}
						{/* signup works but idk how to handle users collaborating yet */}
						{/* <Signup showAuthForm={this.showAuthForm} showForm={this.state.showForm}></Signup> */}
					</div>
				}  
			</div>

		);
	}

	render() {
		return (
			<main>
				<header>
					<div className='logo'>
						<svg enable-background="new 0 0 344.5 344.5" viewBox="0 0 344.5 344.5" xmlns="http://www.w3.org/2000/svg"><path d="m66.4 66.8h-35.2c-4.9 0-8.9-4-8.9-8.9v-4.9c0-4.9 4-8.9 8.9-8.9h35.2c4.9 0 8.9 4 8.9 8.9v4.9c.1 4.9-3.9 8.9-8.9 8.9z" fill="#f5e4e7"/><path d="m66.4 125.3h-35.2c-4.9 0-8.9-4-8.9-8.9v-4.9c0-4.9 4-8.9 8.9-8.9h35.2c4.9 0 8.9 4 8.9 8.9v4.9c.1 4.9-3.9 8.9-8.9 8.9z" fill="#f5e4e7"/><path d="m66.4 183.8h-35.2c-4.9 0-8.9-4-8.9-8.9v-4.9c0-4.9 4-8.9 8.9-8.9h35.2c4.9 0 8.9 4 8.9 8.9v4.9c.1 4.9-3.9 8.9-8.9 8.9z" fill="#f5e4e7"/><path d="m322.3 22.3h-273.4v15.7h20.4c6.8 0 12.4 5.6 12.4 12.6v9.7c0 6.9-5.5 12.6-12.4 12.6h-20.5v23.6h20.4c6.8 0 12.4 5.6 12.4 12.6v9.7c0 6.9-5.5 12.6-12.4 12.6h-20.4v23.6h20.4c6.8 0 12.4 5.6 12.4 12.6v9.5c0 6.9-5.5 12.6-12.4 12.6h-20.4v.3 15.8 7.6h20.4c6.8 0 12.4 5.6 12.4 12.6v9.7c0 6.9-5.5 12.6-12.4 12.6h-20.4v23.6h20.4c6.8 0 12.4 5.6 12.4 12.6v9.7c0 6.9-5.5 12.6-12.4 12.6h-20.4v15.8h273.4v-183.3z" fill="#a86c75"/><path d="m66.4 183.5h-35.2c-4.9 0-8.9-4-8.9-8.9v-4.9c0-4.9 4-8.9 8.9-8.9h35.2c4.9 0 8.9 4 8.9 8.9v4.9c.1 4.9-3.9 8.9-8.9 8.9z" fill="#f5e4e7"/><path d="m66.4 242h-35.2c-4.9 0-8.9-4-8.9-8.9v-4.9c0-4.9 4-8.9 8.9-8.9h35.2c4.9 0 8.9 4 8.9 8.9v4.9c.1 4.9-3.9 8.9-8.9 8.9z" fill="#f5e4e7"/><path d="m66.4 300.5h-35.2c-4.9 0-8.9-4-8.9-8.9v-4.9c0-4.9 4-8.9 8.9-8.9h35.2c4.9 0 8.9 4 8.9 8.9v4.9c.1 4.9-3.9 8.9-8.9 8.9z" fill="#f5e4e7"/><g fill="#fff"><path d="m259.4 135c-16.3 2.3-32.5 9.6-44.3 26.6-4.3-6.4-9.7-11.6-16.8-14.8-.5-.2-1-1.2-1-1.8 0-6.9-2.2-12.9-7-17.8 4.7-7.1 13.4-8.8 20.9-4.2 5.3 3.3 6.4 3.1 9.7-2.3 2.3-3.7 6-5.5 9.9-4.9 4.3.7 7.1 3.6 8 8.2 1 5.2 1.8 5.9 7.1 5.8 5-.1 9.6.8 13.5 5.2z"/><path d="m282.5 207.8c-42.1 0-151.9 0-179.6 0 0 29.1 21.7 54.2 52.9 65.5h-.6c-1.9 0-3.4 1.2-3.4 2.7v3.8c0 1.5 1.5 2.7 3.4 2.7h74.8c1.9 0 3.4-1.2 3.4-2.7v-3.8c0-1.5-1.5-2.7-3.4-2.7h-.6c31.4-11.3 53.1-36.4 53.1-65.5z"/><path d="m279.7 186.3h-174c-1.5 0-2.8 1.3-2.8 2.8v5.5c0 1.5 1.3 2.8 2.8 2.8h174c1.5 0 2.8-1.3 2.8-2.8v-5.5c0-1.5-1.2-2.8-2.8-2.8z"/><path d="m187.9 143.9c-16.7-1.3-29.2 5.6-37.8 20.4-5-5.8-10.9-10.1-17.9-12.6-6.7-2.4-13.7-4.4-20.6-6.6 1-5.7 6.3-10 13.7-10.6.9-.1 1.8 0 2.7 0 7 0 7 0 9.8-6.5 1.8-4.4 6.4-7.8 10.9-7.4 5.2.4 9.8 2.2 12.1 7.4 1.8 4.1 3.6 4.8 7.9 3 9.4-3.8 19.4 2.8 19.2 12.9z"/><path d="m255 176.1c4.1-4.5 8.3-7.3 13.1-9.5 1.5-.7 2.9-2.9 3-4.5.1-1.3-1.5-3-2.8-4-.7-.6-2.4-.4-3.4 0-8.3 3.1-15 8.2-19.5 15.9-.9 1.5-1.7 2.3-3.6 2.2-6.4-.1-12.7-.1-19.1 0-2.7 0-3.4-.7-2.5-3.3 3-8.9 9.3-15.1 16.9-20.1 15.7-10.2 32.8-10.8 50.4-6.6.8.2 1.8 1.7 1.8 2.5-.4 9.1-2.8 17.7-6.3 26.1-.2.6-1.1 1.3-1.6 1.3-8.6 0-17.1 0-26.4 0z"/><path d="m292.1 70.9c-1.4-2.4-3.4-4.7-5.6-6.3-2.1-1.5-5.1-3.2-7.1-2.6s-4.5 3.9-4.5 6c.1 5-2.1 8.1-5.3 11.1-3.1 2.9-5.9 6-8.9 9.1-.3-.5-.6-.9-.9-1.4-2.3.2-4.8 0-7 .7-3.3 1.1-6.3 3.4-9.7 4.3-13.9 3.7-27.3 8.5-39.2 17.2-.8.6-1.6 1.2-2.3 1.8 3.5-.5 6.9-1.3 10.4.9 5.3 3.3 6.7 2.3 8.7-.5 2.5-3.5 7.5-4.8 11.3-4.2 4.3.7 9 2.7 9.9 7.4.6 3.5 1 5.4 6.3 5.3 4.6-.2 7.6.9 11.2 4.3 1.2-3.3 2.3-6.6 3.3-9.9.8-2.6 1.2-5.9 2.9-7.4 3.5-3.1 4.4-6.1 1.7-10.3 1.5-1.3 2.7-2.3 3.9-3.3 5.3-4.8 9.5-11.7 18.2-10.5 1.3.2 4.1-2.6 4.4-4.4.4-2.2-.5-5.1-1.7-7.3z"/><path d="m183.2 176.1c-7.8 0-15.6 0-23.4 0-3.1 0-3.9-.8-2.8-3.8 3.6-10.2 10.7-16.9 21.4-18.8 13.7-2.5 26.2 4.8 31.2 17.7 1.6 4.1 1 4.9-3.3 4.9-7.8 0-15.4 0-23.1 0z"/><path d="m115.9 176.1c-3.6 0-7.3.1-10.9-.1-.9-.1-2-1.3-2.4-2.3-2.3-6.4-4.5-12.9-6.7-19.5 15.6-4 45.4 9.1 50.5 21.9-5.3 0-10.5.1-15.7-.1-.8 0-1.8-.8-2.5-1.5-3.5-3.4-6.9-6.9-10.4-10.4-2.6-2.5-5-2.8-7-.8-2.2 2.1-2.1 4.7.5 7.2 1.6 1.6 3.4 3.1 5.1 4.6-.1.4-.3.7-.5 1z"/><path d="m177.8 121c-4.5-6.9-32.2-49.3-32.2-49.3l13-8.5s29.2 44.5 31.1 47.8c-3.1 2.7-4.8 12.4-11.9 10z"/><path d="m148.9 109.3c5.2.4 9.8 2.2 12.1 7.4 1.8 4.1 3.6 4.8 7.9 3 .2-.1.4-.1.6-.2l-36.2-55.6-13 8.5 24.5 37.5c1.4-.5 2.7-.7 4.1-.6z"/><path d="m134.3 117.9c.8-2 2.2-3.8 3.9-5.1l-18.3-28.1-13 8.5 20.4 31.2c4.4-.1 4.7-.9 7-6.5z"/></g></svg>
					</div>
					{this.renderUser()}
				</header>
				<Meals user={this.state.user} />
				<Footer />
			</main>
		)
	}


}

export default App;
